var map = {
	"./calculator.svg": 195,
	"./excel.svg": 196,
	"./exception_frame.png": 197,
	"./exception_frame.svg": 198,
	"./no_calculator.svg": 199,
	"./no_disconnect.svg": 200,
	"./no_headphones.svg": 201,
	"./no_instant_messaging.svg": 202,
	"./no_internet_browsing.svg": 203,
	"./no_leaving_camera.svg": 204,
	"./no_local_browsing.svg": 205,
	"./no_materials.svg": 206,
	"./no_pause.svg": 207,
	"./no_people_in_room.svg": 208,
	"./no_phone.svg": 209,
	"./no_tv_radio.svg": 210,
	"./notes.svg": 211,
	"./pdf.svg": 212,
	"./people_with_interaction.svg": 213,
	"./people_without_interaction.svg": 214,
	"./powerpoint.svg": 215,
	"./rule_frame.png": 216,
	"./rule_frame.svg": 217,
	"./specific_websites.svg": 218,
	"./textbooks.svg": 219,
	"./word.svg": 220
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 194;